import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-0e44cc56"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "page-pdo-program-detail" }
const _hoisted_2 = { class: "header" }
const _hoisted_3 = { class: "page-title" }
const _hoisted_4 = { class: "collection-method" }
const _hoisted_5 = { class: "jump-wrapper" }

import { onMounted, reactive } from 'vue';
  import { useRoute } from 'vue-router';
  import { useI18n } from 'vue-i18n';
  import { mineBreadcurmbStore } from '@/stores';
  import { PDOType, getPdoDefaultData } from '@/types/pdo';
  import { request } from '@/utils';

  
export default /*#__PURE__*/_defineComponent({
  setup(__props) {

  const route = useRoute();
  const { t } = useI18n();
  const detail = reactive<PDOType>(getPdoDefaultData());
  const routeQuery = reactive({
    title: '',
    programId: ''
  });

  onMounted(async () => {
    const { data } = await request.get<PDOType>(`pdos/mine/pdos/${route.params.id}`);
    Object.assign(detail, data);
    routeQuery.title = data.facility_name;
    routeQuery.programId = String(data.program_id);
    mineBreadcurmbStore.update([
      { name: t('PDO Dashboard'), to: { name: 'pdo.programs' } },
      { name: data.facility_name }
    ]);
  });

return (_ctx: any,_cache: any) => {
  const _component_router_link = _resolveComponent("router-link")!
  const _component_AppCustomLink = _resolveComponent("AppCustomLink")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("h2", _hoisted_3, _toDisplayString(_unref(detail).facility_name), 1),
      _createElementVNode("div", _hoisted_4, _toDisplayString(_unref(t)('Collection method')) + ": " + _toDisplayString(_unref(t)(_unref(detail).collection_method)), 1)
    ]),
    _createElementVNode("div", _hoisted_5, [
      _createVNode(_component_router_link, {
        class: "link-btn",
        to: { name: 'pdo.submission-list', params: { id: _unref(route).params.id }, query: _unref(routeQuery) }
      }, {
        default: _withCtx(() => [
          _createTextVNode(_toDisplayString(_unref(t)('Offline Collection Records')), 1)
        ]),
        _: 1
      }, 8, ["to"]),
      _createVNode(_component_router_link, {
        class: "link-btn",
        to: { name: 'pdo.bin-list', params: { id: _unref(route).params.id }, query: _unref(routeQuery) }
      }, {
        default: _withCtx(() => [
          _createTextVNode(_toDisplayString(_unref(t)('Collection Bin Management')), 1)
        ]),
        _: 1
      }, 8, ["to"]),
      (_unref(detail).collection_method !== 'user_registration')
        ? (_openBlock(), _createBlock(_component_router_link, {
            key: 0,
            class: "link-btn",
            to: { name: 'pdo.submission-new', params: { id: _unref(route).params.id }, query: _unref(routeQuery) }
          }, {
            default: _withCtx(() => [
              _createTextVNode(_toDisplayString(_unref(t)('Creat New Submission')), 1)
            ]),
            _: 1
          }, 8, ["to"]))
        : _createCommentVNode("", true),
      (_unref(detail).program?.slug)
        ? (_openBlock(), _createBlock(_component_AppCustomLink, {
            key: 1,
            class: "link-btn",
            to: { name: 'programs.show', params: { slug: _unref(detail).program?.slug } },
            "custom-domain": _unref(detail).program?.custom_campaign_domain
          }, {
            default: _withCtx(() => [
              _createTextVNode(_toDisplayString(_unref(t)('make_online_collection')), 1)
            ]),
            _: 1
          }, 8, ["to", "custom-domain"]))
        : _createCommentVNode("", true)
    ])
  ]))
}
}

})